var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"table-index-presenter"},[_vm._v("行["+_vm._s(_vm.row)+"] 列["+_vm._s(_vm.column)+"]")])}
var staticRenderFns = []

export { render, staticRenderFns }